import React from "react";

export default function Tabs({ tabs = [], value, onChange }) {
  const isDarkMode = document.documentElement.classList.contains("dark");

  return (
    <div className="flex flex-wrap items-center gap-3 bg-muted px-2 py-1 rounded-lg w-full md:w-fit mb-4">
      {tabs.map((tab) => (
        <button
          key={tab}
          onClick={() => onChange(tab)}
          className={`
            px-4 py-1.5 text-sm font-medium transition-all
            ${value === tab
              ? "bg-accent rounded-lg shadow-sm"
              : "hover:text-foreground"
            }
            ${value === tab && isDarkMode ? "text-black" : ""}
          `}
        >
          {tab}
        </button>
      ))}
    </div>
  );
}
